/**
 * Used when deferring blur handlers so focus moves into VariableMentionPopup or antd portaled overlays
 * do not close the popup (JSON Monaco editor, XPath variable input).
 */
export function isFocusInsideVariableMentionUI(activeEl) {
  if (!activeEl || typeof activeEl.closest !== 'function') return false;
  if (activeEl.closest('[data-variable-mention-popup]')) return true;
  if (activeEl.closest('.ant-select-dropdown')) return true;
  if (activeEl.closest('.ant-calendar-picker-container')) return true;
  return false;
}
